import closeIcon from '../assets/images/icons/CLOSE.svg';
import { fabric } from 'fabric-with-gestures';

const img = document.createElement('img');
img.src = closeIcon;

function deleteObject(eventData: any, transform: any) {
  const target = transform.target;
  const canvas = target.canvas;
  canvas.remove(...canvas.getActiveObjects());
  canvas.discardActiveObject();
  canvas.requestRenderAll();
}

function renderIcon(ctx: any, left: number, top: number, styleOverride: any, fabricObject: any) {
  // @ts-ignore
  const size = this.cornerSize;

  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(img, -size / 2, -size / 2, size, size);
  ctx.restore();
}

/**
 *
 * @param offset
 * @param cornerVisibility
 */
function setDeleteControl(offset: number, cornerVisibility: boolean) {
  fabric.Object.prototype.controls.tr.setVisibility(cornerVisibility);
  // @ts-ignore
  fabric.Object.prototype.controls.deleteControl = new fabric.Control({
    x: 0.5,
    y: -0.5,
    offsetY: -offset,
    offsetX: offset,
    cursorStyle: 'pointer',
    // @ts-ignore
    mouseUpHandler: deleteObject,
    render: renderIcon,
    // @ts-ignore
    cornerSize: 40,
  });
}

export { setDeleteControl };
